/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateStreamConfigResponse
 */
export interface ValidateStreamConfigResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateStreamConfigResponse
     */
    valid: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidateStreamConfigResponse
     */
    errors: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ValidateStreamConfigResponse
     */
    channelUrl?: string;
}

/**
 * Check if a given object implements the ValidateStreamConfigResponse interface.
 */
export function instanceOfValidateStreamConfigResponse(value: object): value is ValidateStreamConfigResponse {
    if (!('valid' in value) || value['valid'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    return true;
}

export function ValidateStreamConfigResponseFromJSON(json: any): ValidateStreamConfigResponse {
    return ValidateStreamConfigResponseFromJSONTyped(json, false);
}

export function ValidateStreamConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateStreamConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'valid': json['valid'],
        'errors': json['errors'],
        'channelUrl': json['channelUrl'] == null ? undefined : json['channelUrl'],
    };
}

export function ValidateStreamConfigResponseToJSON(json: any): ValidateStreamConfigResponse {
    return ValidateStreamConfigResponseToJSONTyped(json, false);
}

export function ValidateStreamConfigResponseToJSONTyped(value?: ValidateStreamConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'valid': value['valid'],
        'errors': value['errors'],
        'channelUrl': value['channelUrl'],
    };
}

